import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './comments-section.scss';

const CommentsSection = ({ comment, changeComment }) => {
  const { t } = useTranslation();

  return (
    <section className="comments-section">
      <label htmlFor="user-comments" className="comments-section_label">
        {t('evieApp.feedback.wellbeingScale.commentsTitle')}
      </label>
      <textarea
        id="user-comments"
        rows="3"
        value={comment}
        className="comments-section_area"
        onChange={changeComment}
      />
    </section>
  );
};

CommentsSection.propTypes = {
  comment: PropTypes.string.isRequired,
  changeComment: PropTypes.func.isRequired,
};

export default CommentsSection;
